<script lang="ts">
  import { ActionType, store, useDispatch } from './Store';
  import { onMount } from 'svelte';

  const dispatch = useDispatch();

  let navBar: HTMLElement;

  const resizeObserver = new ResizeObserver(() => navbarEvent($store.View.mainToTopInPx));
  const navbarEvent = (px) =>
    setTimeout(() => {
      if (document.body.clientWidth <= 600) dispatch({ type: ActionType.setIsNavbarTransparent, payload: false });
      else dispatch({ type: ActionType.setIsNavbarTransparent, payload: px > 0 });
    }, 0);

  onMount(() => {
    resizeObserver.observe(document.body);
    return () => resizeObserver.unobserve(document.body);
  });

  $: navbarEvent($store.View.mainToTopInPx);

  const handleVideo = () => dispatch({ type: ActionType.toggleVideo });
  const handleContact = () => dispatch({ type: ActionType.toggleContact });
</script>

<nav
  bind:this={navBar}
  style={($store.View.isNavbarTransparent && 'background-color: transparent; margin-top: 5em;') || ''}
>
  {#if !$store.View.isNavbarTransparent}
    <div id="title-container" on:click={() => window.location.reload()}><span>Schichteffekt</span></div>
  {/if}
  <div class="logo-buttons-container">
    <img
      id="logo"
      src="favicon.png"
      alt="Logo"
      style={(!$store.View.isNavbarTransparent &&
        'padding: 2%; width: 4em; height: 4em; transform: translate(-50%, 0%);') ||
        ''}
    />
    <div class="buttons-container">
      <div id="video-button-container" on:click={() => handleVideo()}><span>Video</span></div>
      <div id="contact-button-container" on:click={() => handleContact()}><span>Kontakt</span></div>
    </div>
  </div>
</nav>

<style>
  nav {
    position: fixed;
    top: 0;
    left: 0;
    height: 4em;
    right: 0;
    z-index: 99;
    background-color: var(--navBarColor);
    margin-top: 0em;
    transition: margin-top 0.3s linear, background-color 0.3s linear;
  }

  .logo-buttons-container {
    position: absolute;
    right: 0;
    height: 4em;
    width: 25em;
    background-color: var(--navBarColor);
    transition: border-radius 0.3s linear, width 0.3s linear;
  }

  @media screen and (max-width: 800px) {
    .logo-buttons-container {
      width: 50%;
      border-radius: 2em 0 0 2em;
    }
  }

  @media screen and (max-width: 500px) {
    .logo-buttons-container {
      width: 90%;
      border-radius: 2em 0 0 2em;
    }
  }

  .buttons-container {
    position: absolute;
    top: 0;
    padding: 1em;
    padding-left: 4em;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: space-around;
  }

  .buttons-container > div {
    width: 5em;
    height: 100%;
    cursor: pointer;
    background-color: #f0993e;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .buttons-container > div > span {
    margin: auto;
    color: white;
  }

  #logo {
    width: 4em;
    height: 4em;
    transition: width 0.3s linear, height 0.3s linear, transform 0.3s linear, padding 0.3s linear;
  }

  @media screen and (min-width: 801px) {
    #logo {
      width: 8em;
      height: 8em;
      transform: translate(-50%, -50%);
      transition: width 0.3s, height 0.3s, transform 0.3s;
    }
  }

  #title-container {
    background-color: #f0993e;
    position: absolute;
    top: 50%;
    left: 1em;
    transform: translateY(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    height: 2em;
    cursor: pointer;
  }

  #title-container > span {
    margin: 0 1em;
    color: white;
  }

  @media screen and (max-width: 500px) {
    #title-container {
      display: none;
    }
  }
</style>
